import React, {CSSProperties, useCallback, useRef, useState} from 'react'
import {GenerateStars, useClickInside, useClickOutside} from '../../../../app/features'
import {KTSVG} from '../../../helpers'
import {Get} from '../../../../setup'
import {Tooltip, Whisper} from 'rsuite'
import {ImgForm, SatisfactionForm, transformDataFormItem} from '../../../../app/pages/web-forms'
import {Link} from 'react-router-dom'
import {PATH_WEB_FORMS} from '../../../../app/routing/paths'


const GET_DATA_FORMS = process.env.REACT_APP_WEB_FORMS_GET_DATA_FORMS || 'get-data-form/'

type Props = {
    id: string
    index: number
}

export type PropsData = {
    field: string;
    value: string;
    type: string;
    arrayStar: {color: string}[];
}

export function Dropdown4({id, index}: Props) {

    const ref = useRef<HTMLDivElement | null>(null)
    const buttonRef = useRef<HTMLButtonElement | null>(null)

    const endpoint = `${GET_DATA_FORMS}${id}`

    const [toggle, setToggle] = useState<boolean>(false)
    const [data, setData] = useState<PropsData[]>([])

    useClickInside(ref, () => {
        let isMounted = true

        Get<{data: string}>({endpoint})
            .then((response) => {
                if (!isMounted) return

                const transformedResult = transformDataFormItem(response.data).map((item) => {

                    if (typeof item.value !== 'string') {
                        console.warn(`item.value is not a string:`, item.value)
                        return item
                    }

                    if (item.type === 'satisfaction') {
                        const [type, warningStars = '0', totalStars = '0'] = item.value.split('/')

                        if (type === 'star') {
                            item.arrayStar = GenerateStars(+warningStars, +totalStars)
                        } else if (type === 'default') {
                            const filledStarsCount = parseInt(item.value.split(' ')[1], 10) || 0
                            item.arrayStar = GenerateStars(filledStarsCount, 5)
                            item.value = warningStars
                        } else if (type === 'text') {
                            item.value = warningStars
                            item.type = 'satisfaction'
                        }
                    }

                    return item
                })
                setData(transformedResult)
            })
            .catch((error) => {
                if (isMounted) console.log(error)
            })

        if (!toggle) setToggle(true)

        return () => {
            isMounted = false
        }
    })

    useClickOutside(ref, () => {
        if (toggle) setToggle(false)
    })


    const Styles = useCallback(
        (index: number): CSSProperties => {
            if (index === 0 || index === 1) {
                return {
                    zIndex: 105,
                    position: 'absolute',
                    margin: 0,
                    top: '35px',
                    right: '25px',
                }
            }
            return {
                zIndex: 105,
                position: 'absolute',
                margin: 0,
                bottom: '35px',
                right: '25px',
            }
        },
        [])

    return (
        <div className="position-relative d-flex justify-content-center align-content-center" ref={ref}>
            {/* begin::Menu */}
            <Whisper placement="top" controlId="control-id-hover" trigger="hover"
                     speaker={<Tooltip>Description</Tooltip>}>
                <button
                    type="button"
                    className={`btn btn-sm btn-icon btn-color-info btn-active-light-info ${toggle ? 'show menu-dropdown' : ''}`}
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                    data-kt-menu-flip="top-end"
                    ref={buttonRef}
                >
                    <KTSVG path={`/media/icons/duotune/general/gen005.svg`} className="svg-icon-3" />
                </button>
            </Whisper>

            <div
                className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-450px ${toggle ? 'show ' : ''}`}
                style={toggle ? Styles(index) : {}}
            >
                <div className="menu-item bg-light-warning">
                    <div className="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">
                        Description
                        {
                            !data.length && <span className="spinner-border spinner-border-sm align-middle ms-4" />
                        }
                    </div>
                </div>

                <div className="d-flex flex-column">
                    <RenderForm data={data} id={id} />
                </div>
            </div>
            {/* end::Menu */}
        </div>
    )
}


const RenderForm = ({id, data}: {id: string, data: PropsData[]}) => {
    const itemsToDisplay = data.slice(0, 3)

    return (
        <>
            <div className="px-3 pt-4">
                {itemsToDisplay.map((r, i) => (
                    r.type === 'signature' ? (
                        <ImgForm field={r.field} value={r.value} key={i} />
                    ) : r.type === 'satisfaction' ? (
                        <SatisfactionForm field={r.field} stars={r} key={i} />
                    ) : r.type === 'import_file' ? (
                        <></>
                        // <FileUploadForm field={r.field} value={r.value} key={i} />
                    ) : (
                        <div className="row mb-3" key={i}>
                            <label className="col-lg-4 fw-bold text-muted text-capitalize">{r.field}</label>
                            <div className="col-lg-8 fv-row">
                                <span className="fw-bold fs-6">{r.value}</span>
                            </div>
                        </div>
                    )
                ))}
            </div>
            {data.length > 3 && (
                <Link to={`${PATH_WEB_FORMS.form}/${id}`}
                      className="d-flex justify-content-center align-items-center btn btn-color-gray-600 btn-active-color-primary border-top"
                >
                    <span className="me-1">Tout afficher</span>
                    <KTSVG path="/media/icons/duotune/arrows/arr064.svg" className="svg-icon-5" />
                </Link>
            )}
        </>
    )
}

export default RenderForm
